import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Input, Button } from 'antd';
import { CommentOutlined, CopyOutlined } from '@ant-design/icons';
import { useCopyToClipboard } from 'shared/hooks/use-copy-to-clipboard';
import styles from './trip-task-item-comment.module.scss';
import type { ITripTaskItemCommentProps } from './types';

export const TripTaskItemComment: React.FC<ITripTaskItemCommentProps> = (props) => {
  const { comments } = props;
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [text, setText] = useState('');
  const copyToClipboard = useCopyToClipboard();

  if (!comments) return null;

  const handleOpen = () => {
    setText(comments);
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const handleTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setText(e.target.value);
  };

  const copyCommentContent = () => {
    copyToClipboard(text);
  };

  return (
    <>
      <CommentOutlined className={styles.icon} onClick={handleOpen} />
      <Modal
        open={isModalOpen}
        title={t('trip:task_comments')}
        footer={[
          <Button key='copy' icon={<CopyOutlined />} onClick={copyCommentContent}>
            {t('common:copy')}
          </Button>,
        ]}
        onCancel={handleClose}>
        <Input.TextArea value={text} rows={6} onChange={handleTextChange} />
      </Modal>
    </>
  );
};
